import React from 'react';
import {Table , DatePicker, Modal, Form, Icon, Input, Button, message, Radio, Row, Select,Switch,InputNumber } from 'antd';
import {connect} from "react-redux";
import {createAssignSubUserCheckinpoints,findSubUserCheckinpoints} from "../../services/checkinpoint";
import {findSubAccounts} from "../../services/subAccounts";
import lodash from "lodash"
import moment from 'moment';
import {isValidity} from "../../services/global";
import PurchaseServiceTips from "../PurchaseServiceTips";



class EvtViewCheckinpointSubAccount extends React.Component {


 

    constructor(props) {
        super(props);
        this.pstView =null;
        this.state = {
            isMember:'SENIORMEMBER',
            permissionPass: false,
            beginTime:null,
            formLoading: false,
            allSubAcc:[],
            checkinpointSubAcc:[],
            checkedSubAccIds:[],


        }
    }

    componentDidMount() {
        findSubAccounts({userId: 'default'}).then(res => {
            if (res.code === 200) {
                this.setState({allSubAcc: res.data});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
        this.fetchData();
        isValidity('CHECKINTIMING', (vaild) => this.setState({ permissionPass: vaild}));
    }

    componentWillReceiveProps(nextProps) {

    }

    fetchData = () => {
        findSubUserCheckinpoints({checkinpointId: this.props.data.id}).then(res => {
            if (res.code === 200) {
                this.setState({checkinpointSubAcc: res.data});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    onSubmit = () => {
        createAssignSubUserCheckinpoints(Object.assign({checkinpointId:this.props.data.id},{__self__:this.state.checkedSubAccIds})).then(res => {
            if (res.code == 200) {
                message.info("保存成功!");
                this.fetchData();
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            this.changeFormLoading(false)
        })
    }




    render() {
        const {getFieldDecorator, getFieldValue} = this.props.form;
        const {data} = this.props;

        return (
            <div>
                <Modal
                    width={550}
                    title={`签到点-${data.name}(子账号分配管理)`}
                    visible={this.props.visible}
                    onCancel={() => this.props.hide()}
                    footer={null}
                >
                    <div>
                        <Form.Item
                            label="选择所要分配的子账号"
                        >
                            <Select style={{ width: 450 ,}}
                                    mode="multiple"
                                    placeholder="请选择"
                                    onChange={e=>{this.setState({checkedSubAccIds:e})}}
                            >
                                {this.state.allSubAcc.map((obj,index)=>{
                                    return <Select.Option key={index} value={obj.id}>{obj.loginName}</Select.Option>
                                })}
                            </Select>
                            <a href="#" style={{marginLeft:20}} onClick={this.onSubmit}>保存</a>
                        </Form.Item>
                        <Form.Item
                            label="已分配的子账号"
                        >
                            <Table
                                size="small"
                                pagination={false}
                                columns={
                                    [{
                                        title: '企业或组织名',
                                        dataIndex: 'orgName',
                                        width:120,

                                    }, {
                                        title: '登录名',
                                        dataIndex: 'loginName',
                                        width:120,

                                    }, {
                                        title: '授权时间',
                                        dataIndex: 'modifyTime',

                                    }]
                                }
                                dataSource={this.state.checkinpointSubAcc} />

                        </Form.Item>

                    </div>

                </Modal>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember}
                />
            </div>
        );
    }
}


EvtViewCheckinpointSubAccount.contextTypes = {};

EvtViewCheckinpointSubAccount.defaultProps = {};

EvtViewCheckinpointSubAccount.propTypes = {}


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointSubAccount));




// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointSubAccount.jsx